import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/admin`;

class ContentService {
  constructor(getAuthHeader) {
    this.getAuthHeader = getAuthHeader;
  }

  // Home Page Services
  async loadHomeServices() {
    const response = await axios.get(`${API}/home-services`, this.getAuthHeader());
    return response.data;
  }

  async updateHomeService(id, data) {
    const response = await axios.put(`${API}/home-services/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Home Hero
  async loadHomeHero() {
    const response = await axios.get(`${API}/home-hero`, this.getAuthHeader());
    return response.data;
  }

  async updateHomeHero(id, data) {
    const response = await axios.put(`${API}/home-hero/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Home Stats
  async loadHomeStats() {
    const response = await axios.get(`${API}/home-stats`, this.getAuthHeader());
    return response.data;
  }

  async updateHomeStat(id, data) {
    const response = await axios.put(`${API}/home-stats/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Home Quote
  async loadHomeQuote() {
    const response = await axios.get(`${API}/home-quote`, this.getAuthHeader());
    return response.data;
  }

  async updateHomeQuote(id, data) {
    const response = await axios.put(`${API}/home-quote/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Service Hero
  async loadServiceHero(serviceType) {
    const response = await axios.get(`${API}/service-hero/${serviceType}`, this.getAuthHeader());
    return response.data;
  }

  async updateServiceHero(id, data) {
    const response = await axios.put(`${API}/service-hero/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Service Intro
  async loadServiceIntro(serviceType) {
    const response = await axios.get(`${API}/service-intro/${serviceType}`, this.getAuthHeader());
    return response.data;
  }

  async updateServiceIntro(id, data) {
    const response = await axios.put(`${API}/service-intro/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Service Blocks
  async loadServiceBlocks(serviceType) {
    const response = await axios.get(`${API}/service-blocks/${serviceType}`, this.getAuthHeader());
    return response.data;
  }

  async updateServiceBlock(id, data) {
    const response = await axios.put(`${API}/service-blocks/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Service Stats
  async loadServiceStats(serviceType) {
    const response = await axios.get(`${API}/service-stats/${serviceType}`, this.getAuthHeader());
    return response.data;
  }

  async updateServiceStat(id, data) {
    const response = await axios.put(`${API}/service-stats/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Service Process
  async loadServiceProcess(serviceType) {
    const response = await axios.get(`${API}/service-process/${serviceType}`, this.getAuthHeader());
    return response.data;
  }

  async updateServiceProcess(id, data) {
    const response = await axios.put(`${API}/service-process/${id}`, data, this.getAuthHeader());
    return response.data;
  }

  // Service CTA
  async loadServiceCta(serviceType) {
    const response = await axios.get(`${API}/service-cta/${serviceType}`, this.getAuthHeader());
    return response.data;
  }

  async updateServiceCta(id, data) {
    const response = await axios.put(`${API}/service-cta/${id}`, data, this.getAuthHeader());
    return response.data;
  }
}

export default ContentService;
